// MobileSearchOverlay.js
import React from 'react';

const MobileSearchOverlay = ({ isOpen, onClose }) => {
  // console.log(isOpen)
  // console.log(onClose)
  return (
    <div className={`mobile-search-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}>
      <div id="mobileSearchContainer" className={`mobile-search-container  ${isOpen ? 'show' : ''}`}>
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-1 relative">
            <input
              type="text"
              className="mobile-search-bar"
              placeholder="جستجو..."
              id="mobileSearch"
            />
            <svg
              className="search-icon w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{ right: '0.8rem' }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <button
            id="closeMobileSearch"
            className="p-2 text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {/* Quick Search Suggestions */}
        <div className="text-right mb-4">
          <p className="text-sm text-gray-500 font-medium mb-2">
            جستجوهای محبوب:
          </p>
          <div className="flex flex-wrap gap-2 justify-end">
            <span className="search-tag">پایتون</span>
            <span className="search-tag">طراحی سایت</span>
            <span className="search-tag">هوش مصنوعی</span>
            <span className="search-tag">نود جی اس</span>
          </div>
        </div>
        {/* Recent Searches */}
        <div className="text-right">
          <p className="text-sm text-gray-500 font-medium mb-2">
            جستجوهای اخیر:
          </p>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-lg">
              <button className="text-gray-400 hover:text-gray-600">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <span className="text-gray-700">دوره پایتون</span>
            </div>
            <div className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-lg">
              <button className="text-gray-400 hover:text-gray-600">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <span className="text-gray-700">آموزش هوش مصنوعی</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileSearchOverlay;